
const Maddog = () => {


    return (
        <div className='container'>
            <div className='row'>
                <h2>MADDOG</h2>
                <p>
                    This module is currently under construction. Please check back soon!
                </p>
            
            </div>
        </div>
       
    );
};
 
export default Maddog;
